import { useState, useEffect } from 'react';
import PeopleIcon from '@mui/icons-material/People';

import classes from './classes.module.scss';

import {
  jobs
} from 'app/resources';

const CustomersCell = props => {
  const {
    customers,
    customerCount,
    onClick,
    matchedCustomers
  } = props;

  // if there's only one customer,
  // or if customer names have been entered into the filter, then show them.
  // otherwise just show the number of customers
  let text = customerCount;
  if (customers?.length === 1) {
    text = customers[0].name;

  } else if (matchedCustomers?.length) {
    text = matchedCustomers.map(customer => customer.name).join(', ');

    let remaining = customerCount - matchedCustomers.length;
    if (remaining > 0) {
      text += ` (+${remaining})`;
    }
  }

  return (
    <span className={classes.gridLink} onClick={onClick}>
      <PeopleIcon className={classes.gridIcon} />
      {text}
    </span>
  );
}

export default CustomersCell;
